import React from 'react';
import styled from 'styled-components';

const ErrorMessage = ({ hasError, message }) => {
    const StyledErrorMessage = styled.div`
            background-color: white;
            border: 2px solid ${props => props.theme.palette.secondary[500]};
            color: ${props => props.theme.palette.secondary[700]};
    `;

    return (
        hasError ?
            <StyledErrorMessage>
                {message}
            </StyledErrorMessage>
            : null
    );
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/addtocart/ErrorMessage.js